import { render, staticRenderFns } from "./CourseCardButton.vue?vue&type=template&id=64385332&"
import script from "./CourseCardButton.vue?vue&type=script&lang=js&"
export * from "./CourseCardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports